module.exports = __webpack_public_path__ + "img/m_mb.8517b1c4.png";